import { render, staticRenderFns } from "./navTop.vue?vue&type=template&id=320dd208&scoped=true&"
import script from "./navTop.vue?vue&type=script&lang=js&"
export * from "./navTop.vue?vue&type=script&lang=js&"
import style0 from "./navTop.vue?vue&type=style&index=0&id=320dd208&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320dd208",
  null
  
)

export default component.exports